/**
 * Route map of the portal, derived from the V2 mockup. Paths stay in English;
 * the menu labels are translated. See docs/architecture-front-client-hub.md
 * for the mapping between a route and the mockup view it comes from.
 *
 * A detail route serves the three kinds of service (AT, flat rate, payrolling):
 * the mockup duplicates them only because static HTML cannot branch.
 */
export enum AppRoutes {
    HOME = '/',
    DASHBOARD = '/dashboard',
    NEEDS = '/needs',
    NEED_DETAIL = '/needs/:needId',
    ACTIVITY = '/activity',
    SERVICES = '/activity/services',
    SERVICE_DETAIL = '/activity/services/:serviceId',
    COMPLIANCE = '/activity/compliance',
    COMPLIANCE_DETAIL = '/activity/compliance/:checkId',
    DC4 = '/activity/dc4',
    DC4_DETAIL = '/activity/dc4/:dc4Id',
    PARTNERS = '/partners',
    PURCHASE_ORDERS = '/purchase-orders',
    INVOICES = '/invoices',
    DOCUMENTS = '/documents',
}

export enum EventName {
    HOME_PAGE_VIEWED = 'Home Page Viewed',
    DASHBOARD_PAGE_VIEWED = 'Dashboard Page Viewed',
    NEEDS_PAGE_VIEWED = 'Needs Page Viewed',
    NEED_DETAIL_PAGE_VIEWED = 'Need Detail Page Viewed',
    SERVICES_PAGE_VIEWED = 'Services Page Viewed',
    SERVICE_DETAIL_PAGE_VIEWED = 'Service Detail Page Viewed',
    COMPLIANCE_PAGE_VIEWED = 'Compliance Page Viewed',
    COMPLIANCE_DETAIL_PAGE_VIEWED = 'Compliance Detail Page Viewed',
    DC4_PAGE_VIEWED = 'DC4 Page Viewed',
    DC4_DETAIL_PAGE_VIEWED = 'DC4 Detail Page Viewed',
    PARTNERS_PAGE_VIEWED = 'Partners Page Viewed',
    PURCHASE_ORDERS_PAGE_VIEWED = 'Purchase Orders Page Viewed',
    INVOICES_PAGE_VIEWED = 'Invoices Page Viewed',
    DOCUMENTS_PAGE_VIEWED = 'Documents Page Viewed',
}

export const SUPPORT_EVENT_PREFIX = 'PC - ';

export enum DataIntercomTarget {
    CTA_HOME = 'CTA home',
    CTA_DASHBOARD = 'CTA dashboard',
    CTA_NEEDS = 'CTA needs',
    CTA_ACTIVITY = 'CTA activity',
    CTA_PARTNERS = 'CTA partners',
    CTA_PURCHASE_ORDERS = 'CTA purchase orders',
    CTA_INVOICES = 'CTA invoices',
}
